<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
* {
  font-family: "微软雅黑", sans-serif;
  font-size: 9pt;
  position: relative;
  padding: 0;
  margin: 0;
  outline: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
#app,
body,
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  margin: 0 auto;
}
.el-dialog__footer {
  border-top: 1px solid #f5f5f5;
  padding: 10px;
}
.el-dialog__header {
  padding: 10px;
  background: #d51900;
}
.el-dialog__headerbtn {
  top: 10px;
  right: 10px;
  i {
    color: white !important;
  }
}

.el-dialog__title {
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.el-dialog__body {
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue